import { render, staticRenderFns } from "./CVSection.vue?vue&type=template&id=79a1b3c9&scoped=true"
import script from "./CVSection.vue?vue&type=script&lang=js"
export * from "./CVSection.vue?vue&type=script&lang=js"
import style0 from "./CVSection.vue?vue&type=style&index=0&id=79a1b3c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a1b3c9",
  null
  
)

export default component.exports